var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5831,
    y: 29.5833,
    width: 29.1667,
    height: 29.1667,
    rx: 4.58333,
    transform: "rotate(-180 29.5831 29.5833)",
    fill: "#0E151D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.18 21.6292C11.9847 21.4338 11.875 21.1689 11.875 20.8927C11.875 20.6165 11.9847 20.3516 12.18 20.1562L17.3362 15L12.18 9.84374C11.9902 9.64728 11.8852 9.38415 11.8876 9.11103C11.89 8.83791 11.9995 8.57665 12.1927 8.38351C12.3858 8.19038 12.6471 8.08083 12.9202 8.07846C13.1933 8.07608 13.4564 8.18108 13.6529 8.37082L19.5456 14.2635C19.7409 14.4589 19.8506 14.7238 19.8506 15C19.8506 15.2762 19.7409 15.5411 19.5456 15.7364L13.6529 21.6292C13.4576 21.8244 13.1926 21.9341 12.9164 21.9341C12.6402 21.9341 12.3753 21.8244 12.18 21.6292Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5831,
    y: 29.5833,
    width: 29.1667,
    height: 29.1667,
    rx: 4.58333,
    transform: "rotate(-180 29.5831 29.5833)",
    stroke: "#313942",
    strokeWidth: 0.833333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.585965a12947a77c8a6ea0b2ca4dd068.svg";
export { ForwardRef as ReactComponent };